export const BRANCHES = [
  {
    id: "rayasandra",
    name: "Rayasandra Branch",
    shortName: "Seekers Bay Rayasandra",
    address:
      "Seekers Bay Rayasandra, 3, Rayasandra Gattahalli Main Road, Rayasandra, Bangalore (Near SJR Parkway Homes)",
    pin: "560099",
    phone: "76187 59333",
  },
  {
    id: "naganathapura",
    name: "Naganathapura Branch",
    shortName: "Seekers Bay Naganathapura",
    address:
      "Seekers Bay Naganathapura, 42, 3rd Main Road, SLV Layout, Naganathapura, Bangalore",
    pin: "560100",
    phone: "76187 59333",
  },
];

export const PROGRAM_SUMMARIES = [
  {
    id: "toddler-program",
    label: "Toddler Program",
    age: "1.5+",
    desc: "Through guided exploration and interactive play, children will begin developing basic fine motor skills and early social interaction abilities, while being introduced to musical concepts in our nurturing preschool environment.",
    emoji: "🧸",
    color: "bg-teal-100 text-teal-800",
  },
  {
    id: "play-group",
    label: "Play Group",
    age: "2+",
    desc: "Through self-directed exploration and collaborative play, children will  develop their fine motor skills and social communication skills, while  fostering their musical intelligence through our. early education in our preschool",
    emoji: "🧸",
    color: "bg-orange-100 text-orange-800",
  },
  {
    id: "nursery",
    label: "Nursery",
    age: "3+",
    desc: "Children  will demonstrate an understanding of basic shapes and colors, enhance  their creative expression, and engage their bodily-kinesthetic  intelligence through our early education",
    emoji: "🎨",
    color: "bg-pink-100 text-pink-800",
  },
  {
    id: "jr-kg",
    label: "Jr KG",
    age: "4+",
    desc: "Project-based learning that integrates letter recognition,  phonics, and collaborative art creation, children will enhance their  early literacy skills, develop critical thinking and problem-solving  abilities, and engage their spatial and visual-spatial intelligence as part of our early education",
    emoji: "📚",
    color: "bg-indigo-100 text-indigo-800",
  },
  {
    id: "sr-kg",
    label: "Sr KG",
    age: "5+",
    desc: "Through self-directed research in our Preschool, group discussions, and creative  presentations, children will demonstrate their understanding of a chosen  topic, enhance their research and communication skills, and cater to  their individual intelligences as part of our early childhood learning",
    emoji: "🔬",
    color: "bg-violet-100 text-violet-800",
  },
  {
    id: "day-care",
    label: "Day Care",
    age: "1+",
    desc: "Our Preschool's day care is a fun atmosphere engaging the child in indoor and outdoor play. We follow a gadget-free atmosphere to help improve social skills in our child's early education. With choices of  indoor, outdoor play and ambient atmosphere, Children are always engaged .",
    emoji: "☀️",
    color: "bg-yellow-100 text-yellow-800",
  },
];

export const PROGRAM_OPTIONS = PROGRAM_SUMMARIES.map((program) => program.label);

export const SCHOOL_HOURS = {
  statusLabel: "Open today",
  openToday: "08:30 am – 05:00 pm",
  schoolTime: "School time: Monday to Saturday, 08:30 am – 05:00 pm",
  weeklySummary: "Monday to Saturday: 08:30 am – 05:00 pm",
  sunday: "Sunday Closed",
};

export const BRANCH_ADDRESS_TEXT = BRANCHES.map((branch) => branch.address).join(" | ");
